import { __awaiter, __extends, __generator } from "tslib";
import { BaseModel } from '@/core/standard/BaseModel';
import PaymentsService from '@/modules/requests/requestsTables/PaymentsService';
var ExpenseReport = {
  serial: '',
  importe: 0,
  payed_with: '',
  description: '',
  status: '',
  user: null
}; // tslint:disable-next-line:max-line-length

var ExpenseReportModel =
/** @class */
function (_super) {
  __extends(ExpenseReportModel, _super);

  function ExpenseReportModel() {
    var _this = _super.call(this, ExpenseReport, PaymentsService) || this;

    _this.modelName = 'Gastos';
    _this.request = 'JSON';
    return _this;
  } // public async getAllExpenseReports (query: GenericReport, toast) {
  //   const response = await this.service.getAllExpenseReports(query);
  //   if (response && response.data) {
  //     return {data: response.data.results, total: response.data.total};
  //   }
  //   return {data: [], total: 0};
  // }


  ExpenseReportModel.prototype.insertExpenseReport = function (query, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.insertExpenseReport(query)];

          case 1:
            request = _a.sent();

            if (request.complete) {
              this.handleSuccess(request.data, request.message, toast);
              return [2
              /*return*/
              , true];
            } else {
              this.handleError(request, toast);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ExpenseReportModel.prototype.updateExpenseReport = function (query, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.updateExpenseReport(query)];

          case 1:
            request = _a.sent();

            if (request.complete) {
              this.handleSuccess(request.data, request.message, toast);
              return [2
              /*return*/
              , true];
            } else {
              this.handleError(request, toast);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  ExpenseReportModel.prototype.deleteExpenseReport = function (query, toast) {
    return __awaiter(this, void 0, void 0, function () {
      var request;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4
            /*yield*/
            , this.service.deleteExpenseReport(query)];

          case 1:
            request = _a.sent();

            if (request.complete) {
              this.handleSuccess(request.data, request.message, toast);
              return [2
              /*return*/
              , true];
            } else {
              this.handleError(request, toast);
              return [2
              /*return*/
              , false];
            }

            return [2
            /*return*/
            ];
        }
      });
    });
  };

  return ExpenseReportModel;
}(BaseModel);

export default ExpenseReportModel;